import { createApi } from '@reduxjs/toolkit/query/react'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const offerCatalogsApi = createApi({
  reducerPath: 'offerCatalogsApi',
  refetchOnFocus: false,
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    getAvailableCatalogs: builder.query({
      query: (requestParams: { TenantID: string }) =>
        generateRPCQuery(
          apiConstants.OFFER_CATALOGS_RPC_PATH,
          'getAvailableCatalogs',
          requestParams
        )
    }),
    getCatalogProducts: builder.query({
      query: (requestParams: CatalogProductsParams) =>
        generateRPCQuery(
          apiConstants.OFFER_CATALOGS_RPC_PATH,
          'getCatalogProducts',
          requestParams
        )
    }),
    getCatalogCategories: builder.query({
      query: (requestParams: { SocketID: string }) =>
        generateRPCQuery(
          apiConstants.OFFER_CATALOGS_RPC_PATH,
          'getCatalogCategories',
          requestParams
        )
    }),
    getProduct: builder.query({
      query: (requestParams: { SocketID: string; ProductID: string }) =>
        generateRPCQuery(
          apiConstants.OFFER_CATALOGS_RPC_PATH,
          'getProduct',
          requestParams
        )
    }),
    getOfferCatalogPurchases: builder.query({
      query: (requestParams: { TenantID: string; OfferID: string }) =>
        generateRPCQuery(
          apiConstants.OFFER_CATALOGS_RPC_PATH,
          'getOfferCatalogPurchases',
          requestParams
        )
    })
  })
})

export const {
  useGetAvailableCatalogsQuery,
  useGetCatalogProductsQuery,
  useGetCatalogCategoriesQuery,
  useLazyGetProductQuery,
  useLazyGetAvailableCatalogsQuery,
  useGetOfferCatalogPurchasesQuery
} = offerCatalogsApi
